/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Community_Link_LabelInputs */



/**
* | output |
* | --- |
* | "Label" |
*
* @param {Community_Link_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const community_link_label = /** @type {((inputs?: Community_Link_LabelInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Community_Link_LabelInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Libellé")
	if (locale === "es") return /** @type {LocalizedString} */ ("Etiqueta")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Rótulo")
	if (locale === "it") return /** @type {LocalizedString} */ ("Etichetta")
	return /** @type {LocalizedString} */ ("Label")
});